/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  ToolCallSummary,
  ToolCallSummary$inboundSchema,
} from "./toolcallsummary.js";

/**
 * Result of searching tool call summaries
 */
export type SearchToolCallsResult = {
  /**
   * Cursor for next page
   */
  nextCursor?: string | undefined;
  /**
   * List of tool call summaries
   */
  toolCalls: Array<ToolCallSummary>;
};

/** @internal */
export const SearchToolCallsResult$inboundSchema: z.ZodMiniType<
  SearchToolCallsResult,
  unknown
> = z.pipe(
  z.object({
    next_cursor: z.optional(z.string()),
    tool_calls: z.array(ToolCallSummary$inboundSchema),
  }),
  z.transform((v) => {
    return remap$(v, {
      "next_cursor": "nextCursor",
      "tool_calls": "toolCalls",
    });
  }),
);

export function searchToolCallsResultFromJSON(
  jsonString: string,
): SafeParseResult<SearchToolCallsResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => SearchToolCallsResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'SearchToolCallsResult' from JSON`,
  );
}
